import { render, staticRenderFns } from "./m-bujian.vue?vue&type=template&id=2faab8c2&scoped=true&"
import script from "./m-bujian.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-bujian.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-bujian.vue?vue&type=style&index=0&id=2faab8c2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faab8c2",
  null
  
)

export default component.exports